export default __webpack_public_path__ + "static/media/How_to_3.4acacfd1.png";